import { sizer } from "layout/styles/styled/sizer";
import { Button } from "primereact/button";
import { Card } from "primereact/card";
import styled from "styled-components";

export const StyledCard = styled(Card)`
  margin-bottom: ${sizer(4)};
`;

const FIELD_HEIGHT = "2.75rem";

export const StyledFieldGrid = styled.div`
  label {
    color: var(--brand-black);
    font-size: 0.875rem;
    font-weight: var(--font-weight-semibold);
  }

  .p-inputtext {
    width: 100%;
    height: ${FIELD_HEIGHT};
    padding: 0.75rem 1rem;
    border-radius: 12px;
    font-size: 0.875rem;
    color: var(--brand-black);
    background: var(--brand-gray-50);
    border: 1px solid var(--brand-gray-200);
  }

  .p-inputtext::placeholder {
    color: var(--brand-gray-400);
  }

  .p-inputtext:enabled:hover {
    border-color: var(--brand-gray-400);
  }

  .p-inputtext:enabled:focus {
    background: var(--brand-white);
    border-color: var(--brand-purple-500);
    box-shadow: 0 0 0 3px
      color-mix(in srgb, var(--brand-purple-500) 20%, transparent);
  }

  .p-togglebutton.p-button {
    height: ${FIELD_HEIGHT};
  }

  .p-dropdown {
    width: 100%;
    height: ${FIELD_HEIGHT};
    align-items: center;
    border-radius: 12px;
    background: var(--brand-gray-50);
    border: 1px solid var(--brand-gray-200);
    box-shadow: none;
  }

  .p-dropdown:not(.p-disabled):hover {
    border-color: var(--brand-gray-400);
  }

  .p-dropdown:not(.p-disabled).p-focus {
    border-color: var(--brand-purple-500);
    box-shadow: 0 0 0 3px
      color-mix(in srgb, var(--brand-purple-500) 20%, transparent);
  }

  /* PrimeReact puts .p-inputtext on the dropdown's own label, so without this
     the label renders a second bordered box inside the dropdown. */
  .p-dropdown .p-dropdown-label.p-inputtext {
    height: auto;
    padding: 0 0 0 1rem;
    background: transparent;
    border: none;
    box-shadow: none;
  }

  .p-dropdown .p-dropdown-label.p-inputtext:enabled:hover,
  .p-dropdown .p-dropdown-label.p-inputtext:enabled:focus {
    border: none;
    box-shadow: none;
  }

  .p-dropdown-trigger,
  .p-dropdown-clear-icon {
    color: var(--brand-purple-700);
  }
`;

/** The "Enabled / Disabled" pill used in step-card headers. */
export const StyledEnabledToggle = styled.button<{ $enabled: boolean }>`
  display: inline-flex;
  align-items: center;
  gap: 0.5rem;
  flex-shrink: 0;
  padding: 0.5rem 1rem;
  border-radius: 999px;
  cursor: pointer;
  font-size: 0.875rem;
  font-weight: var(--font-weight-semibold);

  background: ${({ $enabled }) =>
    $enabled
      ? "color-mix(in srgb, var(--brand-purple-700) 8%, var(--brand-white))"
      : "color-mix(in srgb, var(--red-500) 8%, var(--brand-white))"};
  border: 1px solid
    ${({ $enabled }) =>
      $enabled
        ? "color-mix(in srgb, var(--brand-purple-700) 25%, var(--brand-white))"
        : "color-mix(in srgb, var(--red-500) 25%, var(--brand-white))"};
  color: ${({ $enabled }) =>
    $enabled ? "var(--brand-purple-700)" : "var(--red-600)"};

  .dot {
    width: 0.5rem;
    height: 0.5rem;
    border-radius: 50%;
    background: ${({ $enabled }) =>
      $enabled ? "var(--brand-purple-700)" : "var(--red-500)"};
  }
`;
